<div [className]="class">
  <img [width]="width" alt="spinner" src="./assets/img/spinner-cuted.gif" />
</div>
